/*
  Quick view modal + Frequently Bought Together row (snippets/fbt-products.liquid).

  The theme's own quick shop (product.modal template) renders a product
  section without price, options or buy button, and a second product section
  on the page would share document-wide variant scripts with the main one.
  So this is self-contained: it reads /products/<handle>.js and draws its own
  gallery, option buttons, price and Add to cart. Adding dispatches the
  theme's ajaxProduct:added event, which refreshes and opens the cart drawer.

  Triggers: any element with data-quick-view="<handle>". A plain left click
  opens the modal; ctrl/cmd/shift/middle clicks keep following the link.

  Ported from iwa-theme. Products with personalisation fields never get
  data-quick-view (snippets/fbt-products.liquid), so they just link.
*/
(function () {
  if (window.iwaQuickView) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var config = { swatchBase: '', strings: {} };
  try {
    var cfgEl = document.getElementById('IwaQuickViewConfig');
    if (cfgEl) config = JSON.parse(cfgEl.textContent);
  } catch (e) {}
  var t = function (key, fallback) { return config.strings[key] || fallback; };

  var cache = {};
  var modal, dialog, content, lastTrigger, state;
  var historyPushed = false;
  // Bumped on every open and on close, so a slow answer can tell whether the
  // sheet it was fetched for is still the one on screen.
  var openSeq = 0;

  window.addEventListener('popstate', function () {
    if (modal && modal.classList.contains('is-open')) close(true);
  });

  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).catch(function (err) {
        delete cache[handle];
        throw err;
      });
    }
    return cache[handle];
  }

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function handleize(s) {
    return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '');
  }

  function sized(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function optionNames(product) {
    return (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  function optionValues(product, i) {
    var o = product.options[i];
    if (o && o.values) return o.values;
    var seen = [];
    product.variants.forEach(function (v) {
      if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]);
    });
    return seen;
  }

  function galleryMedia(product) {
    var list = (product.media || []).map(function (m) {
      var img = m.media_type === 'image' ? m : m.preview_image;
      if (!img || !img.src) return null;
      return { id: m.id, src: img.src, alt: m.alt || product.title };
    }).filter(Boolean);
    if (!list.length) {
      list = (product.images || []).map(function (src) { return { id: null, src: src, alt: product.title }; });
    }
    return list;
  }

  /* ---------- modal shell ---------- */

  function buildShell() {
    modal = document.createElement('div');
    modal.className = 'iwa-qv';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="iwa-qv__overlay" data-qv-close></div>' +
      '<div class="iwa-qv__dialog" role="dialog" aria-modal="true" aria-labelledby="IwaQvTitle" tabindex="-1">' +
        '<button type="button" class="iwa-qv__close" data-qv-close aria-label="' + esc(t('close', 'Close')) + '">' +
          '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="16" height="16"><path d="M2 2l12 12M14 2 2 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="iwa-qv__content" data-qv-content></div>' +
      '</div>';
    document.body.appendChild(modal);
    dialog = modal.querySelector('.iwa-qv__dialog');
    content = modal.querySelector('[data-qv-content]');

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-qv-close]')) close();
    });
    modal.addEventListener('keydown', onKeydown);
    content.addEventListener('click', onContentClick);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      // The theme's document-level Escape handler (search drawer) blurs the
      // active element, which would undo returning focus to the card.
      e.stopPropagation();
      // An open cart drawer under the dialog closes on Escape keyup
      // (window); this Escape was spent on the dialog.
      window.addEventListener('keyup', function swallow(ev) {
        if (ev.key !== 'Escape') return;
        ev.stopPropagation();
        window.removeEventListener('keyup', swallow, true);
      }, true);
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function open(handle, trigger) {
    if (!modal) buildShell();
    var token = ++openSeq;
    lastTrigger = trigger || document.activeElement;
    var card = trigger && trigger.closest('[data-quick-view]');
    var meta = {
      url: (card && card.dataset.url) || (root + 'products/' + handle),
      rating: card && card.dataset.rating,
      raters: card && card.dataset.raters
    };

    content.innerHTML = '<div class="iwa-qv__loading" aria-busy="true"><span class="iwa-qv__spinner"></span></div>';
    content.scrollTop = 0;
    modal.hidden = false;
    // Phone back gesture / back button closes the sheet instead of leaving
    // the page.
    if (!historyPushed && window.history && history.pushState) {
      history.pushState({ iwaQuickView: true }, '');
      historyPushed = true;
    }
    document.documentElement.classList.add('iwa-qv-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    dialog.focus();

    fetchProduct(handle).then(function (product) {
      // Stale answer: the sheet was closed, or reopened for another product.
      if (token !== openSeq || modal.hidden) return;
      render(product, meta);
    }).catch(function () {
      if (token !== openSeq || modal.hidden) return;
      // Fall back to the product page if the data can't be loaded.
      window.location.href = meta.url;
    });
  }

  function close(fromPopstate) {
    if (!modal || modal.hidden || !modal.classList.contains('is-open')) return;
    openSeq++;
    if (historyPushed) {
      historyPushed = false;
      if (fromPopstate !== true) history.back();
    }
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('iwa-qv-open');
    document.dispatchEvent(new CustomEvent('iwaQuickView:closed'));
    setTimeout(function () {
      modal.hidden = true;
      content.innerHTML = '';
    }, 200);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
  }

  /* ---------- render ---------- */

  function render(product, meta) {
    var names = optionNames(product);
    var hasOptions = !(product.variants.length === 1 && names.length === 1 && product.variants[0].title === 'Default Title');
    var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var media = galleryMedia(product);

    state = {
      product: product,
      media: media,
      selected: first.options.slice(),
      variant: first,
      url: meta.url
    };

    var thumbs = media.length > 1 ? media.map(function (m, i) {
      return '<button type="button" class="iwa-qv__thumb' + (i === 0 ? ' is-active' : '') + '" data-qv-thumb="' + i + '" aria-label="' + (i + 1) + ' / ' + media.length + '">' +
        '<img src="' + esc(sized(m.src, 160)) + '" alt="" width="80" height="80" loading="lazy"></button>';
    }).join('') : '';

    var slides = media.map(function (m, i) {
      return '<div class="iwa-qv__slide">' +
        '<img src="' + esc(sized(m.src, 900)) + '" srcset="' + esc(sized(m.src, 600)) + ' 600w, ' + esc(sized(m.src, 900)) + ' 900w, ' + esc(sized(m.src, 1200)) + ' 1200w" sizes="(min-width: 990px) 460px, 92vw" alt="' + esc(m.alt) + '" width="900" height="900"' + (i > 0 ? ' loading="lazy"' : '') + '></div>';
    }).join('');

    var rating = '';
    if (meta.rating && +meta.raters > 0) {
      var pct = Math.max(0, Math.min(100, (+meta.rating / 5) * 100));
      rating = '<a class="iwa-qv__rating" href="' + esc(meta.url) + '#looxReviews">' +
        '<span class="iwa-qv__stars" style="--qv-rating:' + pct.toFixed(1) + '%" aria-hidden="true">★★★★★</span>' +
        '<span>' + (+meta.rating).toFixed(1) + ' (' + esc(meta.raters) + ')</span></a>';
    }

    var options = hasOptions ? names.map(function (name, i) {
      var isColor = /colou?r/i.test(name);
      var buttons = optionValues(product, i).map(function (value) {
        var swatch = isColor && config.swatchBase
          ? '<img class="iwa-qv__swatch" src="' + esc(config.swatchBase + handleize(value) + '.svg') + '" alt="" width="22" height="22" onerror="this.remove()">'
          : '';
        return '<button type="button" class="iwa-qv__value" data-qv-option="' + i + '" data-value="' + esc(value) + '" aria-pressed="false">' + swatch + '<span>' + esc(value) + '</span></button>';
      }).join('');
      return '<div class="iwa-qv__option" role="group" aria-labelledby="IwaQvOpt' + i + '">' +
        '<p class="iwa-qv__option-label" id="IwaQvOpt' + i + '">' + esc(name) + ': <span data-qv-selected="' + i + '"></span></p>' +
        '<div class="iwa-qv__values">' + buttons + '</div></div>';
    }).join('') : '';

    content.innerHTML =
      '<div class="iwa-qv__gallery">' +
        (thumbs ? '<div class="iwa-qv__thumbs">' + thumbs + '</div>' : '') +
        '<div class="iwa-qv__main">' +
          '<div class="iwa-qv__track" data-qv-track>' + slides + '</div>' +
          (media.length > 1 ?
            '<button type="button" class="iwa-qv__arrow iwa-qv__arrow--prev" data-qv-step="-1" aria-label="' + esc(t('previous', 'Previous')) + '"><svg aria-hidden="true" focusable="false" viewBox="0 0 8 14" width="8" height="14"><path d="M7 1 1 7l6 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
            '<button type="button" class="iwa-qv__arrow iwa-qv__arrow--next" data-qv-step="1" aria-label="' + esc(t('next', 'Next')) + '"><svg aria-hidden="true" focusable="false" viewBox="0 0 8 14" width="8" height="14"><path d="m1 1 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
            : '') +
        '</div>' +
      '</div>' +
      '<div class="iwa-qv__info">' +
        '<h2 class="iwa-qv__title" id="IwaQvTitle">' + esc(product.title) + '</h2>' +
        rating +
        '<div class="iwa-qv__price" data-qv-price></div>' +
        options +
        '<form class="iwa-qv__form" data-qv-form action="' + esc(root) + 'cart/add" method="post">' +
          '<input type="hidden" name="id" value="' + first.id + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<div class="product-block"><button type="submit" class="btn btn--full add-to-cart iwa-qv__add" data-qv-add>' +
            '<span>' + esc(t('addToCart', 'Add to cart')) + '</span></button></div>' +
          '<p class="iwa-qv__error" data-qv-error role="alert" hidden></p>' +
        '</form>' +
        '<a class="iwa-qv__details" href="' + esc(meta.url) + '">' + esc(t('viewDetails', 'View full details')) + '</a>' +
      '</div>';

    content.querySelector('[data-qv-track]').addEventListener('scroll', onTrackScroll, { passive: true });
    content.querySelector('[data-qv-form]').addEventListener('submit', onSubmit);

    update(false);
  }

  function onContentClick(e) {
    var thumb = e.target.closest('[data-qv-thumb]');
    if (thumb) {
      goTo(+thumb.dataset.qvThumb);
      return;
    }
    var step = e.target.closest('[data-qv-step]');
    if (step) {
      goTo(currentIndex() + +step.dataset.qvStep);
      return;
    }
    var value = e.target.closest('[data-qv-option]');
    if (value) {
      state.selected[+value.dataset.qvOption] = value.dataset.value;
      update(true);
    }
  }

  function currentIndex() {
    var track = content.querySelector('[data-qv-track]');
    return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }

  function goTo(i) {
    var track = content.querySelector('[data-qv-track]');
    if (!track) return;
    var n = state.media.length;
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    markThumb(i);
  }

  function markThumb(i) {
    content.querySelectorAll('[data-qv-thumb]').forEach(function (b, k) {
      b.classList.toggle('is-active', k === i);
      if (k === i && b.scrollIntoView) {
        var rail = b.parentElement;
        if (rail.scrollHeight > rail.clientHeight) rail.scrollTop = b.offsetTop - rail.clientHeight / 2 + b.clientHeight / 2;
        else rail.scrollLeft = b.offsetLeft - rail.clientWidth / 2 + b.clientWidth / 2;
      }
    });
    var prev = content.querySelector('[data-qv-step="-1"]');
    var next = content.querySelector('[data-qv-step="1"]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= state.media.length - 1;
  }

  var scrollTimer;
  function onTrackScroll() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () { markThumb(currentIndex()); }, 80);
  }

  function findVariant(selected) {
    return state.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    })[0];
  }

  function update(fromUser) {
    var product = state.product;
    var variant = findVariant(state.selected);
    state.variant = variant;

    content.querySelectorAll('[data-qv-option]').forEach(function (btn) {
      var i = +btn.dataset.qvOption;
      var value = btn.dataset.value;
      var selected = state.selected[i] === value;
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      var probe = state.selected.slice();
      probe[i] = value;
      var match = findVariant(probe);
      btn.classList.toggle('is-unavailable', !match || !match.available);
    });
    content.querySelectorAll('[data-qv-selected]').forEach(function (el) {
      el.textContent = state.selected[+el.dataset.qvSelected];
    });

    var priceEl = content.querySelector('[data-qv-price]');
    var add = content.querySelector('[data-qv-add]');
    var idInput = content.querySelector('input[name="id"]');
    if (variant) {
      idInput.value = variant.id;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var saved = variant.compare_at_price - variant.price;
        var saveText;
        if (window.theme && theme.settings && theme.settings.saveType === 'dollar' && theme.strings && theme.strings.savePrice) {
          // Same label as the product page badge (products.general.save_html), whole amounts without ".00".
          var amount = money(saved);
          if (saved % 100 === 0) amount = amount.replace(/[.,]00(?=\D*$)/, '');
          saveText = theme.strings.savePrice.replace('[saved_amount]', amount);
        } else {
          saveText = esc(t('save', 'Save')) + ' ' + Math.round(saved * 100 / variant.compare_at_price) + '%';
        }
        html = '<ins>' + money(variant.price) + '</ins><del>' + money(variant.compare_at_price) + '</del>' +
          '<span class="iwa-qv__save">' + saveText + '</span>';
      } else {
        html = '<span>' + money(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
      add.disabled = !variant.available;
      add.firstChild.textContent = variant.available ? t('addToCart', 'Add to cart') : t('soldOut', 'Sold out');
      if (fromUser && variant.featured_media && variant.featured_media.id) {
        var idx = state.media.map(function (m) { return m.id; }).indexOf(variant.featured_media.id);
        if (idx > -1) goTo(idx);
      }
    } else {
      add.disabled = true;
      add.firstChild.textContent = t('unavailable', 'Unavailable');
    }
    if (!fromUser) markThumb(0);
    var err = content.querySelector('[data-qv-error]');
    if (err) err.hidden = true;
  }

  function onSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var add = form.querySelector('[data-qv-add]');
    var err = form.querySelector('[data-qv-error]');
    if (!state.variant || !state.variant.available) return;
    add.disabled = true;
    add.classList.add('btn--loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: state.variant.id, quantity: 1 }],
        sections: (window.theme && theme.cart && theme.cart.drawerSection) || 'cart-ajax'
      })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    }).then(function (data) {
      add.disabled = false;
      add.classList.remove('btn--loading');
      if (window.theme && theme.settings && theme.settings.cartType === 'page') {
        window.location = (theme.routes && theme.routes.cartPage) || root + 'cart';
        return;
      }
      close();
      // The theme's cart drawer listens for this, rebuilds and opens.
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        // sections: the drawer markup, so it refills without another request.
        detail: { product: data.items ? data.items[0] : data, sections: data.sections },
        bubbles: true
      }));
    }).catch(function (data) {
      add.disabled = false;
      add.classList.remove('btn--loading');
      err.textContent = (data && (data.description || data.message)) || t('addError', "Couldn't add to cart. Please try again.");
      err.hidden = false;
    });
  }

  /* ---------- triggers ---------- */

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-quick-view]');
    if (!card || e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    // Return focus to the card's title link (the photo link is aria-hidden).
    open(card.dataset.quickView, card.querySelector('.fbt__title') || e.target.closest('a, button') || card);
  });

  // Warm the cache when a card is about to be clicked.
  document.addEventListener('pointerover', function (e) {
    var card = e.target.closest && e.target.closest('[data-quick-view]');
    if (card) fetchProduct(card.dataset.quickView).catch(function () {});
  }, { passive: true });

  /* ---------- Frequently Bought Together row arrows ---------- */

  function fbtUpdate(fbt) {
    var track = fbt.querySelector('[data-fbt-track]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var pos = Math.abs(track.scrollLeft);
    fbt.classList.toggle('fbt--fits', max <= 2);
    var prev = fbt.querySelector('[data-fbt-prev]');
    var next = fbt.querySelector('[data-fbt-next]');
    if (prev) prev.disabled = pos <= 2;
    if (next) next.disabled = pos >= max - 2;
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-fbt-prev], [data-fbt-next]');
    if (!arrow) return;
    var fbt = arrow.closest('[data-fbt]');
    var track = fbt && fbt.querySelector('[data-fbt-track]');
    if (!track) return;
    var dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    var step = arrow.hasAttribute('data-fbt-next') ? 1 : -1;
    track.scrollBy({ left: step * dir * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (track && track.matches && track.matches('[data-fbt-track]')) {
      fbtUpdate(track.closest('[data-fbt]'));
    }
  }, { capture: true, passive: true });

  // cart-recommendations.js fires this after swapping in the products.
  document.addEventListener('recommendations:loaded', function (e) {
    var fbt = e.target.querySelector && e.target.querySelector('[data-fbt]');
    if (fbt) fbtUpdate(fbt);
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-fbt]').forEach(fbtUpdate);
  });

  window.iwaQuickView = { open: open, close: close };
})();
